export default __webpack_public_path__ + "static/media/logo-black.7576e5d8.png";